import { render, staticRenderFns } from "./UploadFieldsMapper.vue?vue&type=template&id=5013527b"
import script from "./UploadFieldsMapper.vue?vue&type=script&lang=ts"
export * from "./UploadFieldsMapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports